const testimonials = [
  {
    name: 'Laura Owik',
    project: 'Condo Lobby & Hallway Renovation',
    outcome: 'Dan and his team did an awesome job transforming our condo lobby and hallways. They were sorely in need of updating and Dan helped bring everything up to today\'s times. Dan is very responsive and knowledgeable. His team handles everything — new floor tiles, new ceiling tiles, wall planking, and fresh paint. His main goal is making sure his client is happy. Highly recommend!',
    rating: 5,
    initial: 'L',
  },
  {
    name: 'Judy Stern',
    project: '4-Story, 75-Unit Condo Building Renovation',
    outcome: 'We used Hometown Painters for a total renovation of a 4-story, 75-unit condo building from painting to flooring. Thanks to Dan\'s knowledge and helpful suggestions we were able to get through this project with ease. His crew was accommodating and great to work with — they completed this whole project in under a month with no inconvenience to any of our unit owners. Would most definitely recommend them.',
    rating: 5,
    initial: 'J',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-charcoal-700 py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">Real Client Results</span>
          <h2 className="font-serif text-warm-white text-4xl md:text-5xl mt-3">What Clients Say</h2>
        </div>

        {/* Cards — two large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[1100px] mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-charcoal-800 border border-gold/10 rounded-2xl p-8 flex flex-col hover:border-gold/30 transition-colors duration-200"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-gold" style={{ fontSize: '14px' }} />
                  </div>
                ))}
              </div>

              {/* Quote mark */}
              <div className="font-serif text-gold/20 text-5xl leading-none mb-3">&ldquo;</div>

              {/* Review text */}
              <p className="font-sans text-warm-muted text-sm leading-relaxed flex-1 mb-6 italic">
                &ldquo;{t.outcome}&rdquo;
              </p>

              {/* Client info */}
              <div className="border-t border-gold/10 pt-5 flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-gold/20 rounded-full shrink-0">
                  <span className="font-serif text-gold text-lg font-medium">{t.initial}</span>
                </div>
                <div>
                  <p className="font-serif text-warm-white text-base">{t.name}</p>
                  <p className="font-sans text-gold text-xs mt-0.5 tracking-wide">{t.project}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div className="text-center mt-12">
          <a
            href="#quote"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-gold text-charcoal-900 font-sans font-medium text-sm px-8 py-4 rounded-full hover:bg-gold-light transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Join Our Satisfied Clients
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" style={{ fontSize: '14px' }} />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
